import type { LucideIcon } from 'lucide-react';

// Empty-state placeholder. Tinted purple bg + dashed line border to feel intentional
// rather than "data missing", matching the design's empty pattern.

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
}: {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-line-strong bg-surface-tinted px-8 py-16 text-center">
      <Icon className="mb-4 h-10 w-10 text-brand-purple/60" strokeWidth={1.5} />
      <h3 className="font-heading text-base font-bold text-ink">{title}</h3>
      <p className="mt-1.5 max-w-md text-sm text-ink-faint">{description}</p>
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
